import React, { Component } from 'react';
import axios from "axios";
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import { LangContext } from "../LangContext.jsx";

class UserList extends Component {
  static contextType = LangContext;

  static defaultProps = {
    users: [],
    handleSwitch: null,
    disableActions: false,
    permissions: { users: [] },
    currentPage: 1,
    totalFiles: 0,
    updateCurrentPage: null,
    isOwner: false
  };

  constructor(props) {
    super(props);
    this.state = {
      editPermission: null
    };
  }

  deleteInvitation = (invitation) => {
    const { lang } = this.context;
    
    swal.fire({
        text: "¿Estás seguro que deseas eliminar esta invitación?",
        showCancelButton: true,
        icon: "question",
        buttonsStyling: false,
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        customClass: {
            confirmButton: "btn font-weight-bold btn-danger",
            cancelButton: "btn font-weight-bold btn-secondary"
        }
    }).then((result) => {
        if (result.isConfirmed) {
            window.blockUI();
            axios.delete(
                'api/users/invitation/' + invitation.id,
                {},
                {
                    "headers": {
                        "content-type": "application/json",
                    },
                }
            ).then((response) => {
                window.unblockUI();
                swal.fire({
                    text: getSuccessMessage(response),
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: "Aceptar",
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-light-primary"
                    },
                    timer: 3000
                }).then(function(result) {
                    location.reload()
                });
            })
        }
    });
  }

  deleteUser = async (user) => {
    const result = await swal.fire({
      title: 'Eliminar usuario',
      text: `Escribe el correo del usuario (${user.email}) para habilitar la eliminación.`,
      input: 'text',
      inputPlaceholder: user.email,
      showCancelButton: true,
      icon: 'warning',
      buttonsStyling: false,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      customClass: {
        confirmButton: 'btn font-weight-bold btn-danger',
        cancelButton: 'btn font-weight-bold btn-secondary'
      },
      preConfirm: (value) => {
        if (value !== user.email) {
          swal.showValidationMessage('El correo no coincide.');
          return false;
        }
        return value;
      }
    });

    if (!result.isConfirmed) {
      return;
    }

    try {
      window.blockUI();
      const response = await axios.delete(`/api/users/${user.userId}`, {
        data: {
          email: result.value,
        },
      });
      window.unblockUI();
      await swal.fire({
        text: getSuccessMessage(response),
        icon: 'success',
        buttonsStyling: false,
        confirmButtonText: 'Aceptar',
        customClass: {
          confirmButton: 'btn font-weight-bold btn-light-primary'
        }
      });
      location.reload();
    } catch (error) {
      window.unblockUI();
      swal.fire({
        text: getErrorsMessage(error),
        icon: 'error',
        buttonsStyling: false,
        confirmButtonText: 'Aceptar',
        customClass: {
          confirmButton: 'btn font-weight-bold btn-light-primary'
        }
      });
    }
  }

  getInitials = (name) => {
    const nameList = name.split(' ')
    return nameList.length >= 2 ? `${nameList[0][0]}${nameList[1][0]}` : nameList[0][0]
  }

  render() {
    const { lang } = this.context;
    const { users, handleSwitch, disableActions, permissions, currentPage, totalFiles, updateCurrentPage, isOwner } = this.props;

    return (
      <div className="table-responsive">
        <table className="table table-borderless m-0 table-valign w-100" style={{ tableLayout: 'fixed' }}>
          <thead>
              <tr>
                  <td style={{ width: '40%' }}>{lang.get('messages.usuario')}</td>
                  {!disableActions &&
                  <>
                      <td style={{ width: '20%' }}>{lang.get('messages.centros_de_costos')}</td>
                      <td style={{ width: '15%' }}>{lang.get('messages.perfil')}</td>
                      <td style={{ width: '15%' }}>Estatus</td>
                      <td style={{ width: '10%' }}>{lang.get('messages.acciones')}</td>
                  </>
                  }
                  {disableActions &&
                  <>
                      <td style={{ width: '45%' }}>Estatus</td>
                      <td style={{ width: '15%' }}>Acciones</td>
                  </>
                  }
              </tr>
          </thead>
          <tbody>
          {users.map((user, i) => (
          <tr key={i}>
              <td>
                  <div className="d-flex align-items-center">
                      {/* Avatar Column */}
                      <div className="symbol symbol-40 mr-4">
                          {user.role_id == 1 ? (
                              <div className="symbol-label bg-primary text-white font-weight-bolder">
                                  {this.getInitials(user.name)}
                              </div>
                          ) : (
                              <div className="symbol-label bg-primary-o-40 text-primary font-weight-bolder">
                                  {this.getInitials(user.name)}
                              </div>
                          )}
                      </div>
                      
                      {/* User Info Column */}
                      <div>
                          <div className="d-flex align-items-center">
                              <strong className="mr-2">{user.name}</strong>
                              {user.isOwner && <div className="ownertag">{lang.get('messages.propietario')}</div>}
                          </div>
                          <div className="text-muted">{user.email}</div>
                      </div>
                  </div>
              </td>
              {!disableActions &&
              <>
              <td>
              { user.costCenters && user.costCenters.map((u) => {
                  return(
                      <div key={u.id} >
                          {u.cost_center.name}
                      </div>
                  )
              })}
              </td>
              <td>
              {user.profiles && user.profiles.map((u) => {
                      return(
                          <div key={u.id} >
                              {u.people_profile.name}
                          </div>
                      )
                  })}
              </td>
              </>
              }
              {(!disableActions  )  &&
                  <td>
                  { user.active == 0 ?
                  <div className="active_status">
                      <svg className="mr-2" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="6" fill="#C4C4C4"/></svg>
                      {lang.get('messages.inactivo')}
                  </div>
                  :
                  <div className="active_status">
                      <svg className="mr-2" width="12" height="12" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="6" cy="6" r="6" fill="#08D1AE"/></svg>
                      {lang.get('messages.activo')}
                  </div>
                  }
                  </td>
              }

              {disableActions &&
              <>
              <td>
                  {user.registered ? lang.get('messages.registrado') : lang.get('messages.no_registrado') }
              </td>
              <td>
                  <button onClick={()=>{ this.deleteInvitation(user) }} className="btn btn-xs btn-icon btn-light-secondary mr-4">
                      <i className="flaticon-delete fw-normal text-primary"></i>
                  </button>
              </td>
              </>

              }
              {!disableActions &&
              <td className="text-right text-nowrap" style={{width: '1%'}}>
                   
                   {(user.role_id == 1 && isOwner == true) &&
                  <>
                  { (permissions.users.includes('edit') || permissions.users.includes('all')  ) &&
                      <a href={`/users/${user.userId}/edit`} className="btn btn-xs btn-icon btn-light-secondary mr-2">
                          <i className="flaticon2-edit text-primary"></i>
                      </a>
                  }
                  {!user.isOwner && (permissions.users.includes('delete') || permissions.users.includes('all')) && (
                      <button onClick={() => this.deleteUser(user)} type="button" className="btn btn-xs btn-icon btn-light-secondary mr-2">
                          <i className="flaticon-delete fw-normal text-primary"></i>
                      </button>
                  )}
                  <a href={`/users/${user.userId}`} className="btn btn-xs btn-icon btn-light-secondary mr-2">
                      <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                  </a>
                  </>
                  }
                  {user.role_id != 1 &&
                  <>
                  {!user.isOwner && (permissions.users.includes('delete') || permissions.users.includes('all')) && (
                      <button onClick={() => this.deleteUser(user)} type="button" className="btn btn-xs btn-icon btn-light-secondary mr-2">
                          <i className="flaticon-delete fw-normal text-primary"></i>
                      </button>
                  )}
                  { (permissions.users.includes('edit') || permissions.users.includes('all')  ) &&
                      <a href={`/users/${user.userId}/edit`} className="btn btn-xs btn-icon btn-light-secondary mr-2">
                          <i className="flaticon2-edit text-primary"></i>
                      </a>
                  }
                  
                  <a href={`/users/${user.userId}`} className="btn btn-xs btn-icon btn-light-secondary mr-2">
                      <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                  </a>
                  </>
                  }
              </td>
              }
              </tr>
          ))}
      </tbody>
        </table>
      </div>
    );
  }
}

export default UserList;